// @flow

import React, { Component } from 'react';

import { TextField, Chip } from 'components';
import { withStyles, createStyleSheet } from 'material-ui/styles';

type Props = {
  onAdd: Function,
};

const styleSheet = createStyleSheet('TextFields', theme => ({
  chip: {
    display: 'inline-flex',
    margin: '4px 2px',
  },
}));

class ChipInput extends Component {
  static defaultProps = {
    onAdd: () => {},
    onChange: () => {},
  };

  state = {
    name: '',
    chips: [],
    error: false,
    label: this.props.label,
  };

  handleChange = event => {
    this.setState({ name: event.target.value });
    this.props.onChange(event.target.value, event);
  };

  handleKeyPress = event => {
    if (event.charCode === 13) {
      event.preventDefault();

      const name = this.state.name.trim();

      if (!name) {
        return false;
      }

      if (this.state.chips.some(chip => chip === name)) {
        return this.setState({
          error: true,
          label: '이미 추가 되었습니다.',
        });
      }
      this.setState(
        ({ chips: prevChips }) => ({
          name: '',
          chips: [...prevChips, name],
          error: false,
          label: this.props.label,
        }),
        () => this.props.onAdd({ ...this.state, name })
      );
    }
  };

  componentWillReceiveProps({ label, chips }) {
    if (label) {
      this.setState({
        label,
      });
    }

    if (chips) {
      this.setState({
        chips,
      });
    }
  }
  render() {
    const { classes, className, label, chipProps, ...restProps } = this.props;
    return (
      <div>
        <TextField
          {...restProps}
          label={this.state.label}
          error={this.state.error}
          value={this.state.name}
          onChange={this.handleChange}
          onKeyPress={this.handleKeyPress}
        />

        {this.state.chips.map(chip =>
          <Chip label={chip} className={classes.chip} />
        )}
      </div>
    );
  }
}

export default withStyles(styleSheet)(ChipInput);



// WEBPACK FOOTER //
// ./src/common/components/ChipInput.js